/**
 * Server Configuration - Centralized URL Management
 * Localhost ke liye: VITE_API_DOMAIN=localhost/patakare2
 * Live ke liye: VITE_API_DOMAIN=www.patakare.com
 */

const API_DOMAIN = import.meta.env.VITE_API_DOMAIN || 'www.patakare.com';
const MEDIA_DOMAIN = import.meta.env.VITE_MEDIA_DOMAIN || 'www.patakare.com';

// localhost (or a LAN IP, e.g. testing from a phone against this PC's XAMPP over WiFi)
// ke liye http, baaki ke liye https
const isLocalNetwork = API_DOMAIN.startsWith('localhost') || /^(192\.168\.|10\.|172\.(1[6-9]|2\d|3[01])\.)/.test(API_DOMAIN);
const PROTOCOL = isLocalNetwork ? 'http' : 'https';

// bridgeapi folder directly under project root (no /api/ subfolder on localhost)
export const BRIDGE_API_BASE = `${PROTOCOL}://${API_DOMAIN}/bridgeapi`;

export const BRIDGE_API_URL   = `${BRIDGE_API_BASE}/api.php`;
export const DEV_UPLOADS_BASE = `${PROTOCOL}://${API_DOMAIN}/uploaded_files`;
export const DEV_THUMB_CACHE  = `${DEV_UPLOADS_BASE}/thumb_cache`;
export const PHOTOS_UPLOAD_BASE  = `${PROTOCOL}://${API_DOMAIN}/uploads/photos`;
export const PATIENT_FILES_BASE  = `${PROTOCOL}://${API_DOMAIN}/uploads/patient_files`;
export const UPLOADS_BASE        = `${PROTOCOL}://${API_DOMAIN}/uploads`;
export const API_BASE            = `${PROTOCOL}://${API_DOMAIN}`;
export const SERVE_IMAGE_URL     = `${BRIDGE_API_BASE}/serve-image.php`;
export const AI_CHAT_URL         = `${BRIDGE_API_BASE}/ai-chat.php`;
export const AI_COPILOT_PHP_URL  = `${BRIDGE_API_BASE}/ai-copilot.php`;
export const MEDIA_ADMIN_URL     = `${BRIDGE_API_BASE}/media-admin.php`;

export const PROD_UPLOADS_BASE = `https://${MEDIA_DOMAIN}/uploaded_files`;
export const PROD_THUMB_CACHE  = `${PROD_UPLOADS_BASE}/thumb_cache`;

export function getApiDomain(): string  { return API_DOMAIN; }
export function getMediaDomain(): string { return MEDIA_DOMAIN; }

export function getServeImageUrl(path: string): string {
  return `${SERVE_IMAGE_URL}?path=${encodeURIComponent(path)}`;
}

export function getUserPhotoUrl(userId: number | string, filename: string): string {
  return `${PHOTOS_UPLOAD_BASE}/${userId}/${filename.replace(/^\/+/, '')}`;
}

export function getUploadsUrl(relativePath: string): string {
  const clean = relativePath.startsWith('/') ? relativePath : `/${relativePath}`;
  return `${API_BASE}${clean}`;
}

export function getThumbUrl(filename: string, prefix: string = 'thumb_337_337_'): string {
  return `${DEV_THUMB_CACHE}/${prefix}${filename}`;
}

export function normalizeDevUrl(url: string): string {
  return url.replace(
    'https://www.patakare.com/uploaded_files/',
    `${DEV_UPLOADS_BASE}/`
  );
}

export function getServerEnvironmentInfo() {
  return {
    apiDomain:    API_DOMAIN,
    mediaDomain:  MEDIA_DOMAIN,
    bridgeApiUrl: BRIDGE_API_URL,
    bridgeApiBase: BRIDGE_API_BASE,
    isDev:  API_DOMAIN.includes('localhost') || API_DOMAIN.includes('dev.'),
    label:  `Server (${API_DOMAIN})`,
    shortLabel: API_DOMAIN.includes('localhost') ? 'LOCAL'
              : API_DOMAIN.includes('dev.')      ? 'DEV'
              : 'PROD',
  };
}